import { RotateCw, ServerCrash } from "lucide-react";
import { cn } from "@/lib/utils";

// Два состояния, которые нужны и экрану списка карт, и экрану выпуска.
//
// До этого оба показывали отказ провайдера тостом поверх пустого экрана. Тост
// живёт несколько секунд и уходит, а экран так и остаётся пустым: человек
// видит белое поле и не знает, сломалось у него или у нас. Плюс в тост
// попадала строка, написанная для интегратора, — «[403] Cards API 403 на GET
// /account/info».
//
// Поэтому отказ теперь состояние экрана, а не всплывающее сообщение, и у него
// есть действие: подавляющее большинство таких отказов лечится повтором, а не
// действием пользователя.

export const CardsSkeleton = () => (
  <div className="space-y-4" data-testid="cards-skeleton">
    {/* Пропорции те же, что у CardFace, — экран не дёргается, когда карта
        встаёт на место заглушки. */}
    <div className="lp-glass mx-auto w-full max-w-sm aspect-[1.586/1] animate-pulse rounded-[22px]" />
    <div className="space-y-2">
      <div className="lp-glass h-12 animate-pulse" />
      <div className="lp-glass h-12 animate-pulse" />
    </div>
  </div>
);

export const CardsUnavailable = ({ title, hint, retryLabel, onRetry, className }) => (
  <div
    className={cn("flex flex-col items-center px-6 py-16 text-center", className)}
    data-testid="cards-unavailable"
  >
    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[var(--lp-tile)]">
      <ServerCrash className="h-6 w-6 text-muted-foreground" />
    </div>
    <h2 className="mt-4 text-base font-semibold text-foreground">{title}</h2>
    {hint ? (
      <p className="mt-1 max-w-xs text-sm text-muted-foreground">{hint}</p>
    ) : null}
    {onRetry ? (
      <button
        type="button"
        onClick={onRetry}
        className="lp-press lp-glass mt-5 inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold text-foreground"
        data-testid="cards-retry"
      >
        <RotateCw className="h-4 w-4" />
        {retryLabel}
      </button>
    ) : null}
  </div>
);

export default CardsUnavailable;
